import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-3 w-full grow overflow-hidden rounded-full bg-[#3A424D]">
      <SliderPrimitive.Range className="absolute h-full bg-gradient-to-r from-[#00B4D8] to-[#06D6A0]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-6 w-6 rounded-full border-2 border-[#00B4D8] bg-[#252B33] shadow-lg shadow-[#00B4D8]/30 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00B4D8] hover:scale-110 disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
